import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';
import moment from 'moment';

import LockerOtherUsageView from './LockerOtherUsageView';
import LockerRefundInfoView from './LockerRefundInfoView';

import { ReactComponent as MenuSvg } from '../../../../image/Menu.svg';
import OrangeTrashIcon from '../../../../image/OrangeTrashIcon.png';

export default function LockerHistoryInfoView(props) {
  const {
    data,
    index,
    size,
    onClickLockerModify,
    onClickLockerExtends,
    onClickLockerExit,
    onClickLockerRefund,
    onClickDeleteLockerUsageHistory,
    onClickModifyLockerRefund,
    onClickDeleteLockerRefund,
    onClickDeleteExpectedLocker,
    lockerRendering
  } = props;
  const { t, isEng } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(false);
  const [status, setStatus] = useState(t('memberDetail.statusInUse'));
  const [stateBackground, setStateBackground] = useState(null);
  const [fontColor, setFontColor] = useState(theme.subText);
  const [border, setBorder] = useState(`1px solid ${theme.subBackground}`);
  const [hoverBorder, setHoverBorder] = useState(`1px solid ${theme.primary}`);
  const [backgroundColor, setBackgroundColor] = useState(theme.subBackground);

  const OptionBoxRef = useRef(null);
  const OptionButtonRef = useRef(null);
  const OptionExitRef = useRef(null);
  const OptionPushMessageRef = useRef(null);
  const OptionDeleteRef = useRef(null);
  const OptionExtendRef = useRef(null);
  const OptionRefundRef = useRef(null);

  // 옵션 버튼 크기 설정 //
  useEffect(() => {
    if (OptionBoxRef.current === null) return;
    if (data.isExpectedLocker) return;

    if (isClicked) {
      if (data.status === '사용중') OptionBoxRef.current.style.height = `144px`;
      else OptionBoxRef.current.style.height = `72px`;

      OptionBoxRef.current.style.border = `1px solid ${theme.primary}`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid ${theme.primary}`;
    }
  }, [isClicked, data])

  // 마우스 클릭 리스너 //
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 데이터 세팅 //
  useEffect(() => {
    if (data.status === '사용 종료') {
      setStatus(t('memberDetail.statusUsageEnded'));
      setStateBackground(null);
      setFontColor(theme.text);
      setBorder(`1px solid ${theme.buttonFill}`);
      setHoverBorder(`1px solid ${theme.primary}`);
      setBackgroundColor(theme.buttonFill);
    }
    else if (data.status === '결제 예정') {
      setStatus(t('memberDetail.statusPaymentPending'));
      setStateBackground(theme.subKey);
      setFontColor(theme.text);
      setBorder(`1px solid transparent`);
      setHoverBorder(`1px solid ${theme.primary}`);
      setBackgroundColor(theme.subBackground);
    }
    else {
      // 사용 기한이 끝나지 않은 경우 //
      if (moment().isBefore(moment(data.scheduledEndDate))) {
        setStatus(t('memberDetail.statusInUse'));
        setStateBackground(null);
        setFontColor(theme.text);
        setBorder(`1px solid ${theme.subBackground}`);
        setHoverBorder(`1px solid ${theme.primary}`);
        setBackgroundColor(theme.subBackground);
      }
      // 시작 기한이 도래하지 않은 경우 //
      else if (moment().isBefore(moment(data.startDate))) {
        setStatus(t('memberDetail.statusPlannedUsage'));
        setStateBackground(theme.pointYellow);
        setFontColor(theme.subBackground);
        setBorder(`1px solid ${theme.primary}`);
        setHoverBorder(`1px solid ${theme.primary}`);
        setBackgroundColor(theme.primary);
      }
      // 예정된 기한이 지난경우 //
      else {
        setStatus(t('memberDetail.statusDaysExceeded'));
        setStateBackground(theme.pointRed);
        setFontColor(theme.text);
        setBorder(`1px solid transparent`);
        setHoverBorder(`1px solid ${theme.pointRed}`);
        setBackgroundColor(theme.subBackground);
      }
    }
  }, [data, isDark])

  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target
      && OptionButtonRef.current !== e.target
      && OptionExitRef.current !== e.target
      && OptionPushMessageRef.current !== e.target
      && OptionExtendRef.current !== e.target
      && OptionDeleteRef.current !== e.target
      && OptionRefundRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  function onMouseOverButton() {
    OptionButtonRef.current.style.opacity = 1;
  }

  function onMouseLeaveButton() {
    OptionButtonRef.current.style.opacity = 0;
  }

  // 새로 보여줘야하는 사용일수 표시 //
  function calcUseDate() {
    if (data.isExit) {
      return (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment(data.startDate).format('YYYY-MM-DD')), 'day') + 1) + t('memberDetail.daysSuffix');
    }
    else {
      if (moment(data.endDate).isAfter(moment())) return (moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment(data.startDate).format('YYYY-MM-DD')), 'day') + 1) + t('memberDetail.daysSuffix');
      else return (moment(moment().format('YYYY-MM-DD')).diff(moment(moment(data.startDate).format('YYYY-MM-DD')), 'day') + 1) + t('memberDetail.daysSuffix');
    }
  }

  // 결제 진행된 금액 표시 //
  function calcPaymentState() {
    if (data.selectedPaymentOptions === undefined || data.selectedPaymentOptions.length === 0) {
      if (data.cardPrice === 0 && data.cashPrice === 0) return t('memberDetail.payFree');
      else if (data.cardPrice === 0) return data.cashPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCash');
      else if (data.cashPrice === 0) return data.cardPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCard');
      else return (parseInt(data.cashPrice) + parseInt(data.cardPrice)).toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
    else {
      const allSame = data.selectedPaymentOptions.every(item => item.name === data.selectedPaymentOptions[0].name);
      const totalPrice = data.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);
      const paymentNameMap = { '카드': t('memberDetail.payCard'), '현금': t('memberDetail.payCash'), '포인트': t('memberDetail.payPoint') };

      if (totalPrice === 0) return t('memberDetail.payFree');
      else if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + (paymentNameMap[data.selectedPaymentOptions[0].name] || data.selectedPaymentOptions[0].name);
      else return totalPrice.toLocaleString('ko-KR') + ' - ' + t('memberDetail.payCombined');
    }
  }


  // 사용 기간 표기 //
  function calcUsedDate() {
    const fmt = t('calendarInput.shortDateFormat');
    if (data.isExit) return moment(data.startDate).format(fmt) + ' - ' + moment(data.endDate).format(fmt);
    else return moment(data.startDate).format(fmt) + ' - ' + moment(data.scheduledEndDate).format(fmt);
  }

  // 옵션 버튼 클릭시 //
  function onClickLockerOption() {
    setIsClicked(!isClicked);
  }

  // 몸체 눌렀을때 켜지기 //
  function onClickBody(e) {
    if (OptionButtonRef.current.contains(e.target) || OptionBoxRef.current.contains(e.target)) return;

    onClickLockerModify(data);
  }

  // 사용연장 버튼 클릭시 //
  function onClickExtends() {
    onClickLockerExtends(data);
    setIsClicked(false);
  }

  // 사용종료 버튼 클릭시 //
  function onClickStop() {
    onClickLockerExit(data);
    setIsClicked(false);
  }

  // 락커 환불 버튼 클릭시 //
  function onClickRefund() {
    onClickLockerRefund(data);
    setIsClicked(false);
  }

  // 내역삭제 버튼 클릭시 //
  function onClickDeleteHistory() {
    onClickDeleteLockerUsageHistory(data);
    setIsClicked(false);
  }

  // 정보수정 버튼 클릭시 //
  function onClickModify() {
    onClickLockerModify(data);
    setIsClicked(false);
  }

  const hasSubViews = data.isRefund || (data.otherUsages && data.otherUsages.length > 0);

  function renderPaymentDisplay() {
    if (data.isPending) {
      return (
        <StateWrapper bgColor={theme.subKey}>
          <Text color={theme.subBackground}>{t('memberDetail.statusWaiting')}</Text>
        </StateWrapper>
      );
    }
    const result = calcPaymentState();
    const dashIdx = result.indexOf('  - ');
    if (dashIdx === -1) return <Text color={fontColor}>{result}</Text>;
    return (
      <PaymentDisplayWrapper>
        <Text color={fontColor} style={{ flexShrink: 0 }}>{result.slice(0, dashIdx)}</Text>
        <PaymentMethodText color={fontColor}>{result.slice(dashIdx)}</PaymentMethodText>
      </PaymentDisplayWrapper>
    );
  }

  return (
    <TopLevelWrapper zIndex={60 + size - index}>
      <LockerComponentWrappr zIndex={60 + size - index} hasSubViews={hasSubViews}>
        <LockerComponent
          border={border}
          hoverBorder={hoverBorder}
          backgroundColor={backgroundColor}
          hasSubViews={hasSubViews}
          onMouseOver={onMouseOverButton}
          onMouseLeave={onMouseLeaveButton}
          onClick={onClickBody}>
          <Table>
            <Body>
              <Tr style={{ width: '187px', marginRight: '5px' }}>
                <Td>
                  <TextWrapper style={{ maxWidth: '167px' }}>
                    <Text color={fontColor}>{data.lockerName}</Text>
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr style={{ width: '150px', marginRight: '15px' }}>
                <Td>
                  <TextWrapper style={{ maxWidth: '140px' }}>
                    <Text color={fontColor}>{calcUsedDate()}</Text>
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr style={{ width: '130px', marginRight: '15px' }}>
                <Td>
                  <TextWrapper style={{ maxWidth: '120px' }}>
                    {stateBackground === theme.pointRed
                      ? <Text color={theme.pointRed}>
                          {t('main.locker.extend.daysOver').replace('{days}', moment(moment().format('YYYY-MM-DD')).diff(moment(moment(data.scheduledEndDate).format('YYYY-MM-DD')), 'day'))}
                        </Text>
                      : <Text color={fontColor}>{calcUseDate()}</Text>
                    }
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr style={{ width: '90px', marginRight: '15px' }}>
                <Td>
                  <TextWrapper style={{ maxWidth: '90px' }}>
                    <StateWrapper bgColor={stateBackground}>
                      <Text color={stateBackground ? theme.subBackground : fontColor}>{status}</Text>
                    </StateWrapper>
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr style={{ width: '177px', marginRight: '15px' }}>
                <Td>
                  <TextWrapper style={{ maxWidth: '167px' }}>
                    {renderPaymentDisplay()}
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr style={{ width: '90px', marginRight: '15px' }}>
                <Td>
                  <TextWrapper style={{ maxWidth: '80px' }}>
                    <Text color={fontColor}>{moment(data.approvalDate).format(t('memberDetail.membershipEditModal.dateFormat'))}</Text>
                  </TextWrapper>
                </Td>
              </Tr>
              <Tr>
                {
                  data.isExpectedLocker ?
                    <Td>
                      <IconWrapper ref={OptionButtonRef} onClick={() => onClickDeleteExpectedLocker(data)}>
                        <Icon ref={OptionBoxRef} src={OrangeTrashIcon} />
                      </IconWrapper>
                    </Td>
                    :
                    <Td>
                      <OptionButton ref={OptionButtonRef} onClick={onClickLockerOption} />
                      <OptionWrapper ref={OptionBoxRef}>
                        {data.status === '사용중' && <Option ref={OptionExtendRef} onMouseDown={onClickExtends}>{t('memberDetail.btnExtendUsage')}</Option>}
                        {data.status === '사용중' && <Option ref={OptionExitRef} onMouseDown={onClickStop}>{t('memberDetail.btnEndUsage')}</Option>}
                        {data.status === '사용중' && <Option ref={OptionRefundRef} onMouseDown={onClickRefund}>{t('memberDetail.btnLockerRefund')}</Option>}
                        {data.status !== '사용중' && <Option ref={OptionDeleteRef} onMouseDown={onClickDeleteHistory}>{t('memberDetail.btnDeleteHistory')}</Option>}
                        <Option ref={OptionExtendRef} onMouseDown={onClickModify}>{t('memberDetail.btnModifyInfo')}</Option>
                      </OptionWrapper>
                    </Td>
                }
              </Tr>
            </Body>
          </Table>
        </LockerComponent>

      </LockerComponentWrappr>
      {
        data.isRefund &&
        <ExpertComponentWrapper zIndex={60 + size - index - 1}>
          <LockerRefundInfoView
            data={data}
            onClickDeleteRefund={onClickDeleteLockerRefund}
            onClickModifyRefund={() => onClickModifyLockerRefund(data)} />
        </ExpertComponentWrapper>
      }
      <ExtraUsageWrapper>
        {
          data.otherUsages.map((usage, usageIndex) => (
            <ExpertComponentWrapper key={usage.usageId} zIndex={60 + size - index - usageIndex - 2}>
              <LockerOtherUsageView
                data={usage}
                onClickLockerModify={onClickLockerModify}
                onClickLockerExtends={onClickLockerExtends}
                onClickLockerExit={onClickLockerExit}
                onClickLockerRefund={onClickLockerRefund}
                onClickDeleteLockerUsageHistory={onClickDeleteLockerUsageHistory}
                lockerRendering={lockerRendering} />
            </ExpertComponentWrapper>
          ))
        }
      </ExtraUsageWrapper>
    </TopLevelWrapper>
  )
};

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 970px;

  z-index: ${props => props.zIndex};
`;

const LockerComponentWrappr = styled.div`
  position: relative;

  width: 100%;

  background-color: ${props => props.theme.subBackground};

  border-radius: ${props => props.hasSubViews ? '30px 10px 0 30px' : '30px'};

  z-index: ${props => props.zIndex};
`;

const LockerComponent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 52px;

  border: ${props => props.border};
  border-radius: ${props => props.hasSubViews ? '30px 10px 0 30px' : '30px'};
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: ${props => props.hoverBorder};
    }
  }
`;


const Table = styled.table`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  align-items: center;

  margin-left: 15px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;
`;

const StateWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: ${props => props.bgColor ? '0 5px 1.5px 5px' : '0'};
  border-radius: 5px;
  background-color: ${props => props.bgColor || 'transparent'};

  transition: all 0.3s ease-in-out;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;

const PaymentMethodText = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color};

  margin: 0;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const PaymentDisplayWrapper = styled.div`
  display: flex;
  flex-direction: row;

  min-width: 0;
  overflow: hidden;
`;

const OptionButton = styled(MenuSvg)`
  width: 22px;
  height: auto;
  opacity: 0;

  & rect {
    fill: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;
  height: 0px;

  z-index: 200;

  margin-top: 40px;
  margin-left: -30px;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;;

  justify-content: center;
  align-items: center;

  width: 74px;
  height: 38px;

  margin: 0 0 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.primary};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.subBackground};
      background-color: ${props => props.theme.primary};
    }
  }
`;

const ExtraUsageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const ExpertComponentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  z-index: ${props => props.zIndex};
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  opacity: 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Icon = styled.img`
  width: 100%;
  height: 100%;
`;
